import { Record } from "immutable";
import { DateStringNumber } from ".";
import { checkDate } from "common/helpers/Date";

export const visualizationFromJSON = (json: Partial<IVisualizationData>): VisualizationRecord => {
  const data: IVisualizationRecord = { ...(json as any) };

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    data.updated_at = checkDate(json.updated_at);
  }

  return new VisualizationRecord(data);
};

export interface IVisualizationData {
  id: number;
  job_id: number;
  name: string;
  kind: string;
  target: string;
  data: any;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  sort_order: number;
}

export interface IVisualizationRecord {
  id: number;
  job_id: number;
  name: string;
  kind: string;
  target: string;
  data: any;
  created_at: Date;
  updated_at: Date;
  sort_order: number;
}

const defaultVisualizationProps = {
  id: 0,
  job_id: 0,
  name: "",
  kind: "",
  target: "",
  data: null,
  created_at: new Date(),
  updated_at: new Date(),
  sort_order: 0,
};

export class VisualizationRecord
  extends Record<IVisualizationRecord>(defaultVisualizationProps)
  implements IVisualizationRecord {}
